export default {
    ERRORS: "Ошибки онтологической модели"
};
